var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 14,
    viewBox: "0 0 101 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.500004 7C0.500005 3.41015 3.41015 0.500002 7 0.500002C10.5899 0.500003 13.5 3.41015 13.5 7C13.5 10.5899 10.5899 13.5 7 13.5C3.41015 13.5 0.500004 10.5899 0.500004 7Z",
    fill: "#BEBEBE",
    stroke: "#BEBEBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 7C58.5 3.41015 61.4102 0.500002 65 0.500002C68.5899 0.500003 71.5 3.41015 71.5 7C71.5 10.5899 68.5899 13.5 65 13.5C61.4102 13.5 58.5 10.5899 58.5 7Z",
    stroke: "#BEBEBE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 7C29.5 3.41015 32.4102 0.500002 36 0.500002C39.5899 0.500003 42.5 3.41015 42.5 7C42.5 10.5899 39.5899 13.5 36 13.5C32.4102 13.5 29.5 10.5899 29.5 7Z",
    stroke: "#BEBEBE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5 7C87.5 3.41015 90.4102 0.500002 94 0.500002C97.5899 0.500003 100.5 3.41015 100.5 7C100.5 10.5899 97.5899 13.5 94 13.5C90.4102 13.5 87.5 10.5899 87.5 7Z",
    stroke: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress1);
export default __webpack_public_path__ + "static/media/progress-1.088e688958216f3f88246b3e6d2d50d8.svg";
export { ForwardRef as ReactComponent };